module.exports = __webpack_public_path__ + "e05775e2d66736dfaba975d4c4e69df5.svg";